import React, { useState } from 'react';
import { Helmet } from "react-helmet-async";
import dayjs from 'dayjs';
import {
    ConfigProvider,
    theme,
    Input,
    Select,
    DatePicker,
    Button,
    Upload,
    Avatar,
    Checkbox,
    Space, Tooltip,TimePicker
} from 'antd';
import {
    ChevronDown,
    ChevronRight,
    Search,
    Calendar,
    X,
    Plus,
    UploadCloud,
    RefreshCw,
    AlertTriangle,
    CircleHelp
} from 'lucide-react';
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import Layout from '../../Layout'; // Giữ nguyên layout của bạn
import { Link } from "react-router-dom";
import { mixformatCurrency } from 'services/mixin';

const { TextArea } = Input;
const { Dragger } = Upload;

export default function AddFurlough() {
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [type, setType] = useState('holiday')

    // 1. Quản lý trạng thái Đóng/Mở (Collapse)
    const [expandedSections, setExpandedSections] = useState({
        general: true,
        detail: true,
    });

    const toggleSection = (key) => {
        setExpandedSections(prev => ({ ...prev, [key]: !prev[key] }));
    };

    // 2. Data và State cho detail
    const [details, setDetails] = useState([
        {
            id: 1,
            date: null,
            start: null,
            end: null,
            isWork: 'yes',
            repeat: 'none',
            departments: ['acc'],
            positions: ['analyst'],
            roles: ['director']
        },
    ]);

    const handleAddDetail = () => {
        setDetails([...details, {
            id: Date.now(),
            date: null,
            start: null,
            end: null,
            isWork: 'yes',
            repeat: 'none',
            departments: [],
            positions: [],
            roles: []
        }]);
    };
    const handleRemoveDetail = (id) => {
        setDetails(details.filter(p => p.id !== id));
    };

    const handleDetailChange = (id, field, value) => {
        setDetails(prev =>
            prev.map(item => (item.id === id ? { ...item, [field]: value } : item))
        );
    };

    // Theme Config (Màu chủ đạo #3e91ab)
    const antdThemeConfig = {
        token: {
            colorPrimary: '#3e91ab',
            colorBgContainer: isDarkMode ? '#1f2937' : '#ffffff',
            colorText: isDarkMode ? '#f3f4f6' : '#374151',
            colorBorder: isDarkMode ? '#4b5563' : '#d1d5db',
            borderRadius: 6,
            controlHeight: 40,
        },
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    };

    const SectionHeader = ({ title, sectionKey }) => (
        <div
            onClick={() => toggleSection(sectionKey)}
            className="flex items-center gap-2 text-[#3e91ab] font-medium text-sm mb-4 mt-8 first:mt-0 cursor-pointer hover:opacity-80 transition-opacity select-none"
        >
            {expandedSections[sectionKey] ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
            <span>{title}</span>
        </div>
    );

    return (
        <Layout>
            <Helmet>
                <title> Tạo mới ngày nghỉ | Khothi</title>
            </Helmet>
            <ConfigProvider theme={antdThemeConfig}>
                <div className={`min-h-screen pb-10 transition-colors duration-300`}>

                    {/* Header cố định */}
                    <div className="border-b dark:border-gray-700 px-4 md:px-6 py-3 flex flex-wrap justify-between items-center gap-4 sticky top-[64px] bg-white dark:bg-[#1f1f1f] z-10 shadow-sm">
                        <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                            <div className="flex sm:items-center gap-4 text-sm items-start">
                                <Link to="/furlough" className="flex items-center gap-2">
                                    <LeftOutlined className="w-6 h-6 flex items-center justify-center rounded-full bg-[#3e91ab] hover:bg-[#357f96] text-white" />
                                </Link>
                                {/* <span className="font-medium text-[#3e91ab] border-b-2 border-[#3e91ab] pb-1 cursor-pointer">Thông tin chung</span> */}
                                <span className="pb-1 font-medium">Tạo mới ngày nghỉ</span>
                            </div>
                        </div>
                    </div>

                    {/* Nội dung form */}
                    <div className="w-full mx-auto rounded-lg shadow-sm p-4 md:p-8 mt-6 dark:bg-gray-800 bg-white border dark:border-gray-700">

                        {/* --- 1. THÔNG TIN CHUNG --- */}
                        <SectionHeader title="Thông tin chung" sectionKey="general" />
                        {expandedSections.general && (
                            <div className="w-full lg:w-[50%] flex flex-col gap-4 animate-in slide-in-from-top-2 mb-6">
                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Lý do <span className="text-red-500">*</span></label>
                                    <Input placeholder="Lý do" />
                                </div>
                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Loại nghỉ <span className="text-red-500">*</span></label>
                                    <Select
                                        value={type}
                                        onChange={(e) => setType(e)}
                                        className="w-full"
                                        options={[
                                            { value: 'holiday', label: 'Nghỉ lễ' },
                                            { value: 'unUsual', label: 'Nghỉ bất thường' },
                                            { value: 'timeOff', label: 'Nghỉ sự kiện, nghỉ bù' },

                                        ]} />
                                </div>


                            </div>
                        )}

                        {/* --- 2. Danh sách ngày nghỉ --- */}
                        <div className="flex justify-between items-center mt-8 mb-4">
                            <div
                                onClick={() => toggleSection('detail')}
                                className="flex items-center gap-2 text-[#3e91ab] font-medium text-sm cursor-pointer hover:opacity-80 transition-opacity select-none"
                            >
                                {expandedSections.detail ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                                <span>Danh sách ngày nghỉ</span>
                            </div>
                        </div>

                        {expandedSections.detail && (
                            <div className="animate-in slide-in-from-top-2 mb-6">
                                {type === 'holiday' ? (
                                    <div className="overflow-x-auto pb-4">
                                        <div className="min-w-[1000px]">
                                            {/* Header Row */}
                                            <div className="grid grid-cols-[1.5fr_1fr_1.5fr_2fr_2fr_2fr_auto] gap-3 mb-2 text-[12px] font-normal text-gray-500 dark:text-gray-400 px-1 items-end">
                                                <span>Danh sách ngày nghỉ</span>
                                                <span>Tính công</span>
                                                <span>Lặp</span>
                                                <span>Phòng ban</span>
                                                <span>Vị trí</span>
                                                <span>Chức vụ</span>
                                                <span className="w-6"></span>
                                            </div>

                                            {/* Dynamic Rows */}
                                            {details.map((item) => (
                                                <div key={item.id} className="grid grid-cols-[1.5fr_1fr_1.5fr_2fr_2fr_2fr_auto] gap-3 mb-3 items-center">
                                                    {/* Danh sách ngày nghỉ */}
                                                    <DatePicker
                                                        className="w-full"
                                                        placeholder="dd/mm/yyyy"
                                                        format="DD/MM/YYYY"
                                                        value={item.date}
                                                        onChange={(val) => handleDetailChange(item.id, 'date', val)}
                                                    />

                                                    {/* Tính công */}
                                                    <Select
                                                        disabled
                                                        className="w-full"
                                                        value={item.isWork}
                                                        onChange={(val) => handleDetailChange(item.id, 'isWork', val)}
                                                        options={[
                                                            { value: 'yes', label: 'Có' },
                                                            { value: 'no', label: 'Không' },
                                                        ]}
                                                    />

                                                    {/* Lặp */}
                                                    <Select
                                                        className="w-full"
                                                        value={item.repeat}
                                                        onChange={(val) => handleDetailChange(item.id, 'repeat', val)}
                                                        allowClear
                                                        options={[
                                                            { value: 'none', label: 'Không lặp' },
                                                            { value: 'yearly', label: 'Hàng năm' },
                                                            { value: 'monthly', label: 'Hàng tháng' },
                                                        ]}
                                                    />

                                                    {/* Phòng ban */}
                                                    <Select
                                                        mode="multiple"
                                                        className="w-full"
                                                        placeholder="Chọn phòng ban"
                                                        value={item.departments}
                                                        onChange={(val) => handleDetailChange(item.id, 'departments', val)}
                                                        maxTagCount="responsive"
                                                        allowClear
                                                        options={[
                                                            { value: 'acc', label: 'Phòng kế toán' },
                                                            { value: 'hr', label: 'Phòng nhân sự' },
                                                            { value: 'it', label: 'Phòng IT' },
                                                        ]}
                                                    />

                                                    {/* Vị trí */}
                                                    <Select
                                                        mode="multiple"
                                                        className="w-full"
                                                        placeholder="Chọn vị trí"
                                                        value={item.positions}
                                                        onChange={(val) => handleDetailChange(item.id, 'positions', val)}
                                                        maxTagCount="responsive"
                                                        allowClear
                                                        options={[
                                                            { value: 'analyst', label: 'Chuyên viên' },
                                                            { value: 'dev', label: 'Lập trình viên' },
                                                        ]}
                                                    />

                                                    {/* Chức vụ */}
                                                    <Select
                                                        mode="multiple"
                                                        className="w-full"
                                                        placeholder="Chọn chức vụ"
                                                        value={item.roles}
                                                        onChange={(val) => handleDetailChange(item.id, 'roles', val)}
                                                        maxTagCount="responsive"
                                                        allowClear
                                                        options={[
                                                            { value: 'chairman', label: '(1Office) Chủ tịch HĐQT' },
                                                            { value: 'director', label: 'Giám đốc' },
                                                            { value: 'manager', label: 'Trưởng phòng' },
                                                        ]}
                                                    />

                                                    {/* Xóa dòng */}
                                                    <X
                                                        size={18}
                                                        className="text-gray-400 cursor-pointer hover:text-red-500 ml-1"
                                                        onClick={() => handleRemoveDetail(item.id)}
                                                    />
                                                </div>
                                            ))}

                                            {/* Nút thêm dòng */}
                                            <button onClick={handleAddDetail} className="flex items-center justify-center w-6 h-6 rounded-full border border-[#3e91ab] text-[#3e91ab] hover:bg-[#3e91ab] hover:text-white transition-colors mb-6">
                                                <Plus size={14} />
                                            </button>
                                            {/* <Button
                                                type="dashed"
                                                onClick={handleAddDetail}
                                                icon={<Plus size={16} />}
                                                className="mt-2 text-[#3e91ab] border-[#3e91ab] hover:text-[#357f96] hover:border-[#357f96]"
                                            >
                                                Thêm dòng
                                            </Button> */}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto pb-4">
                                        {/* Tăng min-w để tránh vỡ giao diện trên màn hình nhỏ */}
                                        <div className="min-w-[1150px]">
                                            {/* Header Row: Định dạng 8 cột chuẩn tỉ lệ */}
                                            <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr_2fr_2fr_2fr_40px] gap-3 mb-2 text-[12px] font-normal text-gray-500 dark:text-gray-400 px-1 items-end">
                                                <span>Danh sách ngày nghỉ</span>
                                                <span>Bắt đầu</span>
                                                <span>Kết thúc</span>
                                                <span>Tính công</span>
                                                <span>Phòng ban</span>
                                                <span>Vị trí</span>
                                                <span>Chức vụ</span>
                                                <span className="w-10"></span>
                                            </div>

                                            {/* Dynamic Rows */}
                                            {details.map((item) => (
                                                <div
                                                    key={item.id}
                                                    className="grid grid-cols-[1.5fr_1fr_1fr_1fr_2fr_2fr_2fr_40px] gap-3 mb-3 items-center"
                                                >
                                                    {/* 1. Ngày nghỉ */}
                                                    <DatePicker
                                                        className="w-full"
                                                        placeholder="dd/mm/yyyy"
                                                        format="DD/MM/YYYY"
                                                        value={item.date}
                                                        onChange={(val) => handleDetailChange(item.id, 'date', val)}
                                                    />

                                                    {/* 2. Bắt đầu (Đã sửa field: 'start') */}
                                                    <TimePicker
                                                        className="w-full"
                                                        placeholder="hh:mm"
                                                        format="HH:mm"
                                                        value={item.start}
                                                        onChange={(val) => handleDetailChange(item.id, 'start', val)}
                                                    />

                                                    {/* 3. Kết thúc (Đã sửa field: 'end') */}
                                                    <TimePicker
                                                        className="w-full"
                                                        placeholder="hh:mm"
                                                        format="HH:mm"
                                                        value={item.end}
                                                        onChange={(val) => handleDetailChange(item.id, 'end', val)}
                                                    />

                                                    {/* 4. Tính công */}
                                                    <Select
                                                        className="w-full"
                                                        value={item.isWork}
                                                        onChange={(val) => handleDetailChange(item.id, 'isWork', val)}
                                                        options={[
                                                            { value: 'yes', label: 'Có' },
                                                            { value: 'no', label: 'Không' },
                                                        ]}
                                                    />

                                                    {/* 5. Phòng ban */}
                                                    <Select
                                                        mode="multiple"
                                                        className="w-full"
                                                        placeholder="Chọn phòng ban"
                                                        value={item.departments}
                                                        onChange={(val) => handleDetailChange(item.id, 'departments', val)}
                                                        maxTagCount="responsive"
                                                        allowClear
                                                        options={[
                                                            { value: 'acc', label: 'Phòng kế toán' },
                                                            { value: 'hr', label: 'Phòng nhân sự' },
                                                            { value: 'it', label: 'Phòng IT' },
                                                        ]}
                                                    />

                                                    {/* 6. Vị trí */}
                                                    <Select
                                                        mode="multiple"
                                                        className="w-full"
                                                        placeholder="Chọn vị trí"
                                                        value={item.positions}
                                                        onChange={(val) => handleDetailChange(item.id, 'positions', val)}
                                                        maxTagCount="responsive"
                                                        allowClear
                                                        options={[
                                                            { value: 'analyst', label: 'Chuyên viên' },
                                                            { value: 'dev', label: 'Lập trình viên' },
                                                        ]}
                                                    />

                                                    {/* 7. Chức vụ */}
                                                    <Select
                                                        mode="multiple"
                                                        className="w-full"
                                                        placeholder="Chọn chức vụ"
                                                        value={item.roles}
                                                        onChange={(val) => handleDetailChange(item.id, 'roles', val)}
                                                        maxTagCount="responsive"
                                                        allowClear
                                                        options={[
                                                            { value: 'chairman', label: '(1Office) Chủ tịch HĐQT' },
                                                            { value: 'director', label: 'Giám đốc' },
                                                            { value: 'manager', label: 'Trưởng phòng' },
                                                        ]}
                                                    />

                                                    {/* 8. Nút xóa */}
                                                    <div className="flex justify-center items-center w-10">
                                                        <X
                                                            size={18}
                                                            className="text-gray-400 cursor-pointer hover:text-red-500 transition-colors"
                                                            onClick={() => handleRemoveDetail(item.id)}
                                                        />
                                                    </div>
                                                </div>
                                            ))}

                                            {/* Nút thêm dòng */}
                                            <button
                                                onClick={handleAddDetail}
                                                className="flex items-center justify-center w-6 h-6 rounded-full border border-[#3e91ab] text-[#3e91ab] hover:bg-[#3e91ab] hover:text-white transition-colors mb-6"
                                            >
                                                <Plus size={14} />
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* --- FOOTER BUTTONS --- */}
                        <div className="flex gap-3 pt-6 border-t dark:border-gray-700">
                            <Button type="primary" size="large" style={{ backgroundColor: '#3e91ab', fontWeight: 500 }}>
                                CẬP NHẬT
                            </Button>
                            <Button size="large" className="font-medium">
                                HỦY BỎ
                            </Button>
                        </div>
                    </div>
                </div>
            </ConfigProvider>
        </Layout>
    );
}